import {createDeleteRequest,  makeRequest} from "../utils/apiUtil";

export function deleteResourceType(id) {
    return makeRequest(createDeleteRequest('resourceType/' + id));
}